<template>
  <div>
    <md-table v-model="requestFeedList" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Blood Group"><h4><strong>{{ item.blood_group.blood_group }}</strong></h4></md-table-cell>
        <md-table-cell md-label="Finder Name">{{ item.user.name }}</md-table-cell>
        <md-table-cell md-label="Contact number">{{ item.user.phone_number }}</md-table-cell>
        <md-table-cell md-label="Posted on">{{ item.created_at.date }}</md-table-cell>
        <md-table-cell md-label="Expected on">{{ item.last_date_to_contact}}</md-table-cell>
        <md-table-cell md-label="Location">{{ item.local_area}}</md-table-cell>
        <md-table-cell md-label="Action"><button class="donate"><span>Donate</span></button></md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
  var moment = require('moment');
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        selected: [],
        requestFeedList:[]
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetRequestFeedList').then((response)=> {
        console.log('RequestfeedList', response);
        this.requestFeedList = response.data.data;
        this.requestFeedList.forEach((request)=>{
          request.created_at.date = moment(request.created_at.date).format('YYYY-MM-DD');

        })
      })
    }
  }
</script>
<style>
  .donate {
    border-radius: 4px;
    background-color: rgba(175, 31, 21, 0.9) !important;
    padding: 5px;
    width: auto;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    transition: all 0.5s;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px;

  }

 /* .donate span {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  .donate span:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    top: 0;
    right: -20px;
    transition: 0.5s;
  }

  .donate:hover span {
    padding-right: 15px;
  }

  .donate:hover span:after {
    opacity: 1;
    right: 0;
  }*/
</style>
